import { render, staticRenderFns } from "./CrumbsComponent.vue?vue&type=template&id=3621398e&"
import script from "./CrumbsComponent.vue?vue&type=script&lang=ts&"
export * from "./CrumbsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports